import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { bambooDict } from "@/lib/shop/products/bamboo";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/shop_/bamboo")({
  head: () => ({
    ...buildProductHead(bambooDict),
    links: alternateLinkList("/shop/bamboo", "en"),
  }),
  component: () => <ProductPage dict={bambooDict} />,
});